import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/Login";
import HomeLayout from "./Layouts/HomeLayout/HomeLayout";
import EmailSupport from "./Pages/Home/EmailSupport";
import Home from "./Pages/Home/Home";
import SupportTickets from "./Pages/Support/SupportTickets";
import CreateOrUpdateTicket from "./Pages/Support/CreateOrUpdateTicket";
import TicketDetail from "./Pages/Support/TicketDetail";
import CreateOrUpdateOrganization from "./Pages/Organization/CreateOrUpdateOrganization";
import ManageOrganizations from "./Pages/Organization/ManageOrganizations";
import LoginLayout from "./Layouts/LoginLayout/LoginLayout";
import ForgetPassword from "./Pages/Login/ForgetPassword";

export default function Router() {
  return (
    <Routes>
      <Route element={<HomeLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/email-support" element={<EmailSupport />} />
        <Route path="/support-tickets" element={<SupportTickets />} />
        <Route
          path="/support-tickets/create-ticket"
          element={<CreateOrUpdateTicket />}
        />
        <Route
          path="/support-tickets/detail/:ticket_id"
          element={<TicketDetail />}
        />
        <Route
          path="/support-tickets/edit-ticket/:ticket_id"
          element={<CreateOrUpdateTicket />}
        />
        <Route path="/create-organization" element={<CreateOrUpdateOrganization />} />
        <Route path="/manage-organizations" element={<ManageOrganizations />} />
        <Route
          path="/manage-organizations/update-organization/:organization_id"
          element={<CreateOrUpdateOrganization />}
        />
      </Route>
      <Route element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
      </Route>
    </Routes>
  );
}
